import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import FlagstoneTheme from '../../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export default function StandstillPopup(props) {

    const classes = useStyles();
    const { t } = useTranslation();
    const [radioValue, setRadioValue] = useState(1);

    const handleChange = (event) => {
        setRadioValue(event.target.value);
    };

    function PaperComponent(props) {
        return (
            <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper {...props} />
            </Draggable>
        );
    }

    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle className={classes.dialogTitle}>
                {t("Stilstand gedetecteerd")}
            </DialogTitle>
            <DialogContent >
                <DialogContentText className={classes.dialogContext}>
                    <FormControl>
                        <FormLabel id="demo-controlled-radio-buttons-group">{t("Geef aan wat de oorzaak is")}</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="demo-controlled-radio-buttons-group"
                            value={radioValue}
                            onChange={handleChange}
                            className={classes.radioGroup}
                        >
                            <FormControlLabel value={1} control={<Radio />} label={t("Technische Stilstand")} />
                            <FormControlLabel value={2} control={<Radio />} label={t("Geplande Stilstand")} />
                            <FormControlLabel value={3} control={<Radio />} label={t("Kuisen")} />
                        </RadioGroup>
                    </FormControl>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.cancelButton} onClick={props.closeDialog} >
                        {t("CANCEL")}
                    </Button>
                    <Button className={classes.submitButton} onClick={() => props.action(radioValue)} >
                        {t("INDIENEN")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "520px !important",
        height: "420px !important",
        margin: "auto"
    },
    buttons: {
        width: "520px",
        textAlign: "center"
    },
    cancelButton: {
        border: "1px solid " + FlagstoneTheme.palette.primary.main,
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        margin: "3px",
        width: "100px",
        marginBottom: "20px",
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            color: "white",

        },

    },
    submitButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        border: "1px solid " + FlagstoneTheme.palette.primary.main,
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: "white",
            color: FlagstoneTheme.palette.primary.main,

        },
        margin: "3px",
        width: "100px",
        marginBottom: "20px"
    },

    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    headerIcon: {
        height: "80px",
        width: "100%",
        marginTop: "20px",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box"
    },
    radioGroup: {
        display: "contents !important"
    }
}));
